import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as AdhocReportModels from '@ptg-member/types/models/adhoc-report.model';
import { SortType } from '@ptg-shared/constance';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdhocReportService {
  constructor(private httpClient: HttpClient) { }

  getCardList(query: AdhocReportModels.GetCardListRequest): Observable<AdhocReportModels.GetCardListForReportResponse> {
    let params = new HttpParams();
    params = params.append('entityId', query.entityId);
    return this.httpClient.get<AdhocReportModels.GetCardListForReportResponse>(`${environment.apiUrl}/members/adhoc-report/manage-template/get-cards`, { params });
  }

  getDefaultFilter(query: AdhocReportModels.GetDefaultFilterRequest): Observable<AdhocReportModels.GetDefaultFilterResponse> {
    let params = new HttpParams();
    params = params.append('type', query.type);
    return this.httpClient.get<AdhocReportModels.GetDefaultFilterResponse>(`${environment.apiUrl}/members/adhoc-report/manage-template/get-default-filter`, { params });
  }

  getDefaultTemplate(query: AdhocReportModels.GetDefaultTemplateRequest): Observable<AdhocReportModels.GetDefaultTemplateResponse> {
    let params = new HttpParams();
    params = params.append('type', query.type);
    return this.httpClient.get<AdhocReportModels.GetDefaultTemplateResponse>(`${environment.apiUrl}/members/adhoc-report/manage-template/get-default-template`, { params });
  }

  getCardConfiguration(query: AdhocReportModels.GetCardConfigurationRequest): Observable<AdhocReportModels.GetCardConfigurationResponse> {
    let params = new HttpParams();
    params = params.append('cardId', query.cardId);
    params = params.append('type', query.type);
    if (query.componentId) {
      params = params.append('componentId', query.componentId);
    }
    return this.httpClient.get<AdhocReportModels.GetCardConfigurationResponse>(`${environment.apiUrl}/members/adhoc-report/manage-template/get-card-configuration`, { params });
  }

  getTemplates(): Observable<AdhocReportModels.GetTemplatesResponse> {
    return this.httpClient.get<AdhocReportModels.GetTemplatesResponse>(`${environment.apiUrl}/members/adhoc-report/manage-template/get-templates`);
  }

  getTemplate(query: AdhocReportModels.GetTemplateRequest): Observable<AdhocReportModels.GetTemplateResponse> {
    let params = new HttpParams();
    params = params.append('templateId', query.templateId);
    return this.httpClient.get<AdhocReportModels.GetTemplateResponse>(`${environment.apiUrl}/members/adhoc-report/manage-template/get-template`, { params });
  }

  generateAdhocReport(request: AdhocReportModels.GenerateAdhocReportRequest): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/members/adhoc-report/generate`, request);
  }

  createReportTemplate(request: AdhocReportModels.CreateReportTemplateRequest): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}/members/adhoc-report/manage-template/create-template`, request);
  }

  updateReportTemplate(request: AdhocReportModels.UpdateReportTemplateRequest): Observable<any> {
    let params = new HttpParams();
    params = params.append('templateId', request.templateId);
    return this.httpClient.put(`${environment.apiUrl}/members/adhoc-report/manage-template/update-template`, request, { params });
  }

  removeReportTemplate(query: AdhocReportModels.RemoveReportTemplateRequest): Observable<any> {
    let params = new HttpParams();
    params = params.append('templateId', query.templateId);
    return this.httpClient.delete(`${environment.apiUrl}/members/adhoc-report/manage-template/remove-template`, { params });
  }

  removeReportAuditTrail(query: AdhocReportModels.RemoveReportAuditTrail): Observable<any> {
    let params = new HttpParams();
    params = params.append('reportId', query.reportId);
    return this.httpClient.delete(`${environment.apiUrl}/members/adhoc-report/remove`, { params })
  }

  getAdhocReport(query: AdhocReportModels.GetAdhocReportRequest): Observable<AdhocReportModels.GetAdhocReportResponse> {
    let params = new HttpParams();
    if (query?.sortNames?.length) {
          params = params.append('SortNames', query.sortNames);
          params = params.append('SortType', query?.sortType ?? SortType.ASC);
        }
        if (query?.pageSize && query?.pageNumber) {
          params = params.append('PageSize', query.pageSize);
          params = params.append('PageIndex', query.pageNumber);
        }
    return this.httpClient.get<AdhocReportModels.GetAdhocReportResponse>(`${environment.apiUrl}/members/adhoc-report`, { params });
  }
}
